module.exports = __webpack_public_path__ + "img/7.0b71941e.jpg";